
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import { formDownload } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import { getDateRange } from "@common/src/utils/common";

const base = namespace("base");
const staff = namespace("staff");
const serviceItem = namespace("service-item");
const finance = namespace("finance");
const parts = namespace("parts");
const partsCategory = namespace("parts-category");

const defaultTime = getDateRange("first_day_to_today_of_current_month", "YYYYMMDD");

@InjectFunction(
  "dayjs",
  "emptyToLine",
  "splitThousands",
  "permit",
  "permitApp",
  "appCode",
  "addCurrencySymbol",
  "addCurrencyUnit"
)
@Component({ components: { TextTips } })
@Table("loadListData")
export default class ServiceList extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @serviceItem.Action queryTwoLevelClassList;
  @finance.Action orderProductValueQueryList;
  @serviceItem.Action getServiceItemList;
  @parts.Action getPartsList;
  @partsCategory.Action getCategoryList;
  outputList: any[] = [];
  searchForm = {
    orderTimeStart: "",
    orderTimeEnd: "",
    completedTimeStart: "",
    completedTimeEnd: "",
    settlementTimeStart: "",
    settlementTimeEnd: "",
    productType: "",
    orderType: "",
    serviceCategoryCode: "",
    serviceItemCode: "",
    partsCategoryCode: "",
    partsCode: "",
    additionalFeeFlag: "",
    showLevel: "1"
  };

  created() {
    this.init();
    this.searchParts("");
  }
  mounted() {
    (this.$refs.searchBar as any).search();
  }
  serviceItemClassList: any = [];
  productValueTypeList = [];
  orderTypeList = [];
  async init() {
    this.getDictionaryList("product_value_type").then(data => {
      this.productValueTypeList = data;
    });
    this.getDictionaryList("order_type").then(data => {
      this.orderTypeList = data;
    });
    this.queryTwoLevelClassList({
      serviceCategoryName: "",
      serviceClass: "",
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      this.serviceItemClassList = this.$safeValue(data, "data.list").map(item => {
        item.label = item.serviceCategoryName;
        item.value = item.serviceCategoryCode;
        return item;
      });
    });
    this.handleSearchServiceItemList("");
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  sumData = {};
  @Table.LoadDataMethod()
  loadListData() {
    return this.orderProductValueQueryList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.sumData = data.data;

      this.outputList = data.data?.list || [];
      return data;
    });
  }
  valueType = "";
  get searchList() {
    return [
      {
        label: t("v210831.document-creation-date"),
        type: "daterange",
        value: "",
        prop: "orderTime",
        maxDay: 365,
        valueDistribute: ["orderTimeStart", "orderTimeEnd"]
      },
      {
        label: t("v3_2_0.completion-time-of-documents"),
        type: "daterange",
        value: "",
        prop: "completedTime",
        maxDay: 365,
        valueDistribute: ["completedTimeStart", "completedTimeEnd"]
      },
      {
        label: t("v210831.document-settlement-time-not"),
        type: "daterange",
        value: defaultTime,
        resetValue: defaultTime,
        prop: "settlementTime",
        maxDay: 365,
        valueDistribute: ["settlementTimeStart", "settlementTimeEnd"]
      },
      {
        label: t("other.order-type"),
        type: "select",
        selectList: this.orderTypeList,
        value: "",
        prop: "orderType"
      },
      {
        label: t("v3_2_0.output-value-type"),
        type: "select",
        selectList: this.productValueTypeList,
        value: "",
        prop: "productType",
        changeMethod: this.valueTypeChange
      },
      {
        label: t("setting.classification-service"),
        type: "select",
        selectList: this.serviceItemClassList,
        if: this.valueType === "service",
        value: "",
        prop: "serviceCategoryCode"
      },
      {
        label: t("finance.service-items"),
        type: "select-search",
        value: "",
        prop: "serviceItemCode",
        placeholder: t("v210906.enter-service-item-keyword-query"),
        if: this.valueType === "service",
        selectList: this.serviceItemList,
        searchFun: this.handleSearchServiceItemList
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        if: this.valueType === "parts",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: t("parts.text"),
        type: "select-search",
        value: "",
        prop: "partsCode",
        placeholder: t("v210901.enter-spare-parts-search"),
        if: this.valueType === "parts",
        selectList: this.partsList,
        searchFun: this.searchParts
      }
    ].filter(item => item.if !== false);
  }
  partsList: any = [];
  searchParts(partsName) {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        return {
          label: item.partsName,
          value: item.partsCode
        };
      });
    });
  }
  handleSearch(type, data) {
    console.log(213, data);
    this.searchForm.showLevel = "1";
    this.mix_pageNum = 1;
    this.clearCode();
    if (type === "reset") {
      this.valueTypeChange("");
    }
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value?.[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.nextStack = [
      {
        ...this.searchForm
      }
    ];
    this.loadListData();
  }
  serviceItemList: any = [];
  handleSearchServiceItemList(serviceItemName = "") {
    this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: serviceItemName
    }).then(data => {
      this.serviceItemList = this.$safeValue(data, "data.list", []).map(item => {
        return {
          label: item.serviceName,
          value: item.serviceCode
        };
      });
    });
  }
  categoryList: any[] = [];
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  nextStack: any = [
    {
      productType: "",
      productCode: ""
    }
  ];
  get hierarchy() {
    return this.nextStack.length;
  }
  get isLastLevel() {
    if (this.searchForm.additionalFeeFlag === "1" || this.hierarchy === 3) {
      return true;
    }
    return false;
  }
  get stackTop() {
    return this.nextStack[this.nextStack.length - 1] || {};
  }
  getCategoryText(row) {
    return row.categoryDesc || "-";
  }
  getNextData(row) {
    if (this.isLastLevel) {
      return;
    }
    const tempPrams: any = {};
    if (row.productType === "parts") {
      if (this.hierarchy === 1) {
        this.searchForm.partsCategoryCode = row.productCode;
        tempPrams.partsCategoryCode = row.productCode;
      } else if (this.hierarchy === 2) {
        this.searchForm.partsCode = row.productCode;
        tempPrams.partsCode = row.productCode;
      }
    } else if (row.productType === "service") {
      if (this.hierarchy === 1) {
        this.searchForm.serviceCategoryCode = row.productCode;
        tempPrams.serviceCategoryCode = row.productCode;
      } else if (this.hierarchy === 2) {
        this.searchForm.serviceItemCode = row.productCode;
        tempPrams.serviceItemCode = row.productCode;
      }
    } else {
      this.searchForm.additionalFeeFlag = "1";
      tempPrams.additionalFeeFlag = "1";
    }
    this.nextStack.push({
      ...this.searchForm,
      productType: row.productType,
      productName: row.productName,
      showLevel: this.hierarchy + 1
    });
    this.searchForm.showLevel = row.productType === "additionalFee" ? "3" : String(this.hierarchy);
    this.mix_pageNum = 1;
    this.loadListData();
    // this.searchForm.serviceItemCode= row.productCode
  }
  handleBack() {
    // 倒退到栈顶第二个
    this.nextStack.pop();
    this.searchForm.showLevel = String(this.hierarchy);
    const nextStackTop = this.nextStack[this.nextStack.length - 1];
    this.searchForm.serviceCategoryCode = "";
    this.searchForm.serviceItemCode = "";
    this.searchForm.partsCode = "";
    this.searchForm.partsCategoryCode = "";
    this.searchForm.additionalFeeFlag = "";
    this.mix_sortParams = [
      {
        item: "",
        type: ""
      }
    ];
    Object.assign(this.searchForm, nextStackTop);
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleExportData() {
    formDownload(`${window.API_URL}/report/orderProductValue/export`, this.searchForm);
  }
  handleGoOutputValueChart() {
    window.open(this.$router.resolve("/finance/report-output-value-chart").href);
  }
  clearCode() {
    this.searchForm.partsCategoryCode = "";
    this.searchForm.partsCode = "";
    this.searchForm.serviceCategoryCode = "";
    this.searchForm.serviceItemCode = "";
    this.searchForm.additionalFeeFlag = "";
  }
  handToPayOrder(row) {
    window.open(this.$router.resolve(`/finance/payment-order-view/${row.paymentNo}`).href);
  }
  valueTypeChange(val) {
    console.log(val);
    this.valueType = val;
    if (val === "service") {
      this.searchForm.partsCategoryCode = "";
      this.searchForm.partsCode = "";
    } else if (val === "parts") {
      this.searchForm.serviceCategoryCode = "";
      this.searchForm.serviceItemCode = "";
    } else {
      this.searchForm.partsCategoryCode = "";
      this.searchForm.partsCode = "";
      this.searchForm.serviceCategoryCode = "";
      this.searchForm.serviceItemCode = "";
    }
  }
}
